import { call, put, select, takeLatest } from 'redux-saga/effects';

import { addCustomGTMEvent } from '../../../events';
import { formatError } from '../../../libs';
import { mapGtmProduct } from '../../../libs/gtm/mapGtmProduct';
import deliveryAPI from '../../api/delivery';
import { Creators as CartCreators } from '../../reducers/cart';
import { Creators as CheckoutCreators } from '../../reducers/checkout';
import { Creators as DeliveryCreators, Types } from '../../reducers/delivery';
import { Creators as FreightsCreators } from '../../reducers/freights';
import { Creators as StoresCreators } from '../../reducers/stores';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* deliveryRequest({ isChangeQuantity, sellerId }) {
  const {
    app: { asPath, config: domainConfig },
    cart,
    customer,
    delivery,
    freights: { cartFreight },
    stores,
  } = yield select(getState);

  const token = yield select(getToken);

  const selectedDelivery = delivery.getIn(['selectedDelivery', sellerId]);

  try {
    const cartId = cart.id || customer.cartId || getCartId();
    const isCheckout = asPath.includes('checkout');
    const { siteId } = domainConfig;
    const config = {};

    // Verifica se o tipo do delivery é LOJA, adiciona os params
    if (selectedDelivery.isStore && !isChangeQuantity) {
      config.idLoja = selectedDelivery.id;
      config.cep = stores.getIn(['cep', sellerId]);
    }

    // Verifica se o tipo do delivery é FRETE, adiciona os params
    if (selectedDelivery.isFreight || isChangeQuantity) {
      config.idTransportadora = selectedDelivery.id;
      config.cep = cartFreight.cep;
    }

    const data = yield call(deliveryAPI.setDelivery, siteId, cartId, sellerId, token, config);

    if (config?.idTransportadora) {
      const freightPrice = data?.options?.find((option) => option.id === config?.idTransportadora)?.price || undefined;

      addCustomGTMEvent({
        event: 'success_add_shipping_info',
        data: {
          currency: 'BRL',
          value: freightPrice,
          items: mapGtmProduct({ products: cart?.sellers?.[0]?.lines, seller: cart?.sellers?.[0]?.seller }),
        },
      });
    } else if (config?.idLoja) {
      addCustomGTMEvent({
        event: 'success_add_remove_in_place',
        data: {
          store: config?.idLoja,
          cep: config?.cep,
          items: mapGtmProduct({ products: cart?.sellers?.[0]?.lines, seller: cart?.sellers?.[0]?.seller }),
        },
      });
    }

    // Limpa frete selecionado em caso de alternância de entrega pelo usuário
    if (selectedDelivery.isStore) {
      yield put(FreightsCreators.selectFreight({ [sellerId]: null }));
    }

    // Limpa loja selecionado em caso de alternância de entrega pelo usuário
    if (selectedDelivery.isFreight) {
      yield put(StoresCreators.selectStore({ [sellerId]: null }));
    }

    if (isChangeQuantity && config.idTransportadora) {
      yield put(FreightsCreators.cartFreightSuccess(data));
    }

    // Faz recalculo de parcelas do checkout
    if (isCheckout) {
      yield put(CheckoutCreators.getPaymentTypesRequest(cartId));
    }

    // Chama carrinho para atualizar as informações
    yield put(CartCreators.cartRequest());

    yield put(DeliveryCreators.deliverySuccess());
  } catch (error) {
    addCustomGTMEvent({
      event: 'error_add_shipping_info',
      data: {
        error: error?.message || '',
      },
    });
    yield put(DeliveryCreators.deliveryFailed({ [sellerId]: { ...formatError(error), cart: true } }));

    if (selectedDelivery.isFreight) {
      yield put(FreightsCreators.selectFreight({ [sellerId]: null }));
    }

    if (selectedDelivery.isStore) {
      yield put(StoresCreators.selectStore({ [sellerId]: null }));
    }

    yield put(CartCreators.cartRequest());
  }
}

export default function* watch() {
  yield takeLatest(Types.DELIVERY_REQUEST, deliveryRequest);
}
